import { useEffect, useState } from 'react';
import ModalDialog from '../../components/modal_dialog';
import { fetch as apiFetch } from '../../utils/api-wrapper';
import toast from 'react-hot-toast';

const DEFAULTS = {
  automatic_match_window_days: 1,
  manual_candidate_window_days: 7,
  amount_tolerance_cents: 0,
  automatic_matching_mode: 'enabled',
};

const StatementImportSettingsModal = ({ data, onClose }) => {
  const [settings, setSettings] = useState(DEFAULTS);
  const [amountTolerance, setAmountTolerance] = useState('0.00');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    apiFetch('/c_card/statement-import-settings', 'GET', {}, (response) => {
      const next = { ...DEFAULTS, ...(response.data || {}) };
      setSettings(next);
      setAmountTolerance((Number(next.amount_tolerance_cents || 0) / 100).toFixed(2));
      setLoading(false);
    }, () => {
      setLoading(false);
      toast.error(data.t.read('cc_statements.statement_imports.statement_import_settings.load_failed'));
    });
  }, [data.t]);

  const update = (field, value) => {
    setSettings((current) => ({ ...current, [field]: value }));
  };

  const save = () => {
    const tolerance = Number(amountTolerance);
    if (!Number.isFinite(tolerance) || tolerance < 0 || tolerance > 1) {
      toast.error(data.t.read('cc_statements.statement_imports.statement_import_settings.invalid_amount_tolerance'));
      return false;
    }

    setSaving(true);
    apiFetch('/c_card/statement-import-settings', 'PUT', {
      ...settings,
      amount_tolerance_cents: Math.round(tolerance * 100),
    }, () => {
      setSaving(false);
      toast.success(data.t.read('cc_statements.statement_imports.statement_import_settings.saved'));
      onClose();
    }, () => {
      setSaving(false);
      toast.error(data.t.read('cc_statements.statement_imports.statement_import_settings.save_failed'));
    });
    return false;
  };

  return (
    <ModalDialog
      title={data.t.read('cc_statements.statement_imports.statement_import_settings.title')}
      // width='640px'
        size={"sm"}
      dividers
      cancelAction={onClose}
      cancelText={data.t.read('cancel')}
      okAction={save}
      okText={data.t.read('save')}
      okLoading={saving}
      invalid={loading || saving}
      noProcessingLoading
      onClose={onClose}
    >
      {loading ? (
        <div className='d-flex justify-content-center p-3'>
          <span className='spinner-border' role='status' aria-label={data.t.read('please_wait')} />
        </div>
      ) : (
        <div className='statement-import-settings'>
          <h5 className='mt-2 text-muted text-uppercase small d-block mb-3'>
            {data.t.read('cc_statements.statement_imports.statement_import_settings.matching_section')}
          </h5>
          <div className='form-group mb-4'>
            <label className='text-muted text-uppercase small d-block mb-1' htmlFor='automatic-match-window-days'>
              {data.t.read('cc_statements.statement_imports.statement_import_settings.automatic_match_window_days')}
            </label>
            <input id='automatic-match-window-days' className='form-control' type='number' min='0' max='30' step='1'
              value={settings.automatic_match_window_days}
              onChange={(event) => update('automatic_match_window_days', Number(event.target.value))} />
          </div>
          <div className='form-group mb-4'>
            <label className='text-muted text-uppercase small d-block mb-1' htmlFor='manual-candidate-window-days'>
              {data.t.read('cc_statements.statement_imports.statement_import_settings.manual_candidate_window_days')}
            </label>
            <input id='manual-candidate-window-days' className='form-control' type='number' min='0' max='90' step='1'
              value={settings.manual_candidate_window_days}
              onChange={(event) => update('manual_candidate_window_days', Number(event.target.value))} />
          </div>
          <div className='form-group mb-4'>
            <label className='text-muted text-uppercase small d-block mb-1' htmlFor='amount-tolerance'>
              {data.t.read('cc_statements.statement_imports.statement_import_settings.amount_tolerance')}
            </label>
            <input id='amount-tolerance' className='form-control' type='number' min='0' max='1' step='0.01'
              value={amountTolerance} onChange={(event) => setAmountTolerance(event.target.value)} />
          </div>
          <div className='form-group mb-0'>
            <label className='text-muted text-uppercase small d-block mb-1' htmlFor='automatic-matching-mode'>
              {data.t.read('cc_statements.statement_imports.statement_import_settings.automatic_matching_mode')}
            </label>
            <select id='automatic-matching-mode' className='form-control' value={settings.automatic_matching_mode}
              onChange={(event) => update('automatic_matching_mode', event.target.value)}>
              <option value='enabled'>{data.t.read('cc_statements.statement_imports.statement_import_settings.mode_enabled')}</option>
              <option value='review_only'>{data.t.read('cc_statements.statement_imports.statement_import_settings.mode_review_only')}</option>
              <option value='disabled'>{data.t.read('cc_statements.statement_imports.statement_import_settings.mode_disabled')}</option>
            </select>
          </div>
        </div>
      )}
    </ModalDialog>
  );
};

export default StatementImportSettingsModal;
